import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, LinkText, Button } from '@components/common';
import { MobileContainer, DesktopContainer } from '@containers/layout';
import HSvsDCModal from './HSvsDCModal';
import HSvsDCDiff from './HSvsDCDiff';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import BookingBoardView from './BookingBoard';

const PKG_DISCOUNT_THRESHOLD = 7500;

const DesktopWrapper = styled(DesktopContainer)`
  @media screen and (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;
  z-index: 100;
  @media screen and (max-width: 767px) {
    flex: 0;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding-top: 0px;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

const MobileOnly = styled(Box)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const DesktopOnly = styled(Box)`
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: block;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
`;

function ServiceTypeRecurring(props) {
  const [show, toggleModal] = useState(false);
  const { totalPrice, onSubmit, selectedItems } = props;

  const showBanner = !totalPrice || totalPrice < PKG_DISCOUNT_THRESHOLD;

  const isDisabled = !selectedItems || !selectedItems.length;

  return (
    <DesktopWrapper>
      <MobileOnly>
        <Button
          my={2}
          width={1}
          type="button"
          onClick={onSubmit}
          disabled={isDisabled}
        >
          Continue
        </Button>
      </MobileOnly>
      <Box flex={1}>
        <BookingBoardView flex={1} showBanner={showBanner} />
      </Box>

      <ContainerView>
        <Box position="relative" pt={[4, 0]}>
          <LinkText
            display={['block', 'none']}
            textAlign={['center', 'left']}
            px={2}
            mb={4}
            onClick={() => toggleModal(true)}
          >
            What&apos;s the difference between cleans?
          </LinkText>

          <DesktopOnly px={2}>
            <HSvsDCDiff />

            <Button
              disabled={isDisabled}
              my={2}
              width={1}
              type="button"
              onClick={onSubmit}
            >
              Continue
            </Button>
          </DesktopOnly>
        </Box>
      </ContainerView>
      <HSvsDCModal show={show} dismiss={() => toggleModal(false)} />
    </DesktopWrapper>
  );
}

ServiceTypeRecurring.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  allPackages: PropTypes.object,
  totalPrice: PropTypes.number,
  currentPackage: PropTypes.string,
  setCurrentPackage: PropTypes.func,
  selectedItems: PropTypes.array
};

const mapStatesToProps = state => ({
  allPackages: ScheduleSelectors.selectAllPackages(state),
  currentPackage: ScheduleSelectors.selectPackage(state),
  totalPrice: ScheduleSelectors.selectScheduledPrice(state),
  selectedItems: ScheduleSelectors.selectScheduledItems(state)
});

const mapDispatchToProps = dispatch => ({
  setCurrentPackage: packageType =>
    dispatch(ScheduleActions.setCurrentPackage(packageType))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ServiceTypeRecurring);
